var map = {
	"./amplify-amazon-button_5.entry.js": [
		1068,
		28
	],
	"./amplify-auth-container.entry.js": [
		1069,
		29
	],
	"./amplify-auth-fields_9.entry.js": [
		1070,
		30
	],
	"./amplify-authenticator.entry.js": [
		1071,
		15
	],
	"./amplify-button_3.entry.js": [
		1072,
		31
	],
	"./amplify-chatbot.entry.js": [
		1073,
		6
	],
	"./amplify-checkbox.entry.js": [
		1074,
		32
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		1075,
		16
	],
	"./amplify-container.entry.js": [
		1076,
		33
	],
	"./amplify-federated-buttons_2.entry.js": [
		1077,
		34
	],
	"./amplify-federated-sign-in.entry.js": [
		1078,
		35
	],
	"./amplify-form-field_4.entry.js": [
		1079,
		36
	],
	"./amplify-greetings.entry.js": [
		1080,
		37
	],
	"./amplify-icon-button.entry.js": [
		1081,
		38
	],
	"./amplify-icon.entry.js": [
		1082,
		17
	],
	"./amplify-link.entry.js": [
		1083,
		39
	],
	"./amplify-nav_2.entry.js": [
		1084,
		40
	],
	"./amplify-photo-picker.entry.js": [
		1085,
		41
	],
	"./amplify-picker.entry.js": [
		1086,
		42
	],
	"./amplify-radio-button_3.entry.js": [
		1087,
		18
	],
	"./amplify-s3-album.entry.js": [
		1088,
		19
	],
	"./amplify-s3-image-picker.entry.js": [
		1089,
		20
	],
	"./amplify-s3-image.entry.js": [
		1090,
		21
	],
	"./amplify-s3-text-picker.entry.js": [
		1091,
		22
	],
	"./amplify-s3-text.entry.js": [
		1092,
		23
	],
	"./amplify-select-mfa-type.entry.js": [
		1093,
		43
	],
	"./amplify-sign-in-button.entry.js": [
		1094,
		24
	],
	"./amplify-tooltip.entry.js": [
		1095,
		44
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1054;
module.exports = webpackAsyncContext;